const GOOGLE_MAPS_LANGUAGE_BY_REGION = {
  AD: 'ca',
  AE: 'ar',
  AF: 'fa',
  AL: 'sq',
  AM: 'hy',
  AO: 'pt',
  AR: 'es',
  AT: 'de',
  AU: 'en',
  AZ: 'az',
  BA: 'bs',
  BD: 'bn',
  BE: 'nl',
  BG: 'bg',
  BH: 'ar',
  BO: 'es',
  BR: 'pt',
  BY: 'be',
  CA: 'en',
  CH: 'de',
  CL: 'es',
  CN: 'zh-CN',
  CO: 'es',
  CR: 'es',
  CU: 'es',
  CY: 'el',
  CZ: 'cs',
  DE: 'de',
  DK: 'da',
  DO: 'es',
  DZ: 'ar',
  EC: 'es',
  EE: 'et',
  EG: 'ar',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GB: 'en',
  GE: 'ka',
  GR: 'el',
  GT: 'es',
  HK: 'zh-HK',
  HN: 'es',
  HR: 'hr',
  HU: 'hu',
  ID: 'id',
  IE: 'en',
  IL: 'iw',
  IN: 'hi',
  IQ: 'ar',
  IR: 'fa',
  IS: 'is',
  IT: 'it',
  JP: 'ja',
  KR: 'ko',
  LI: 'de',
  LT: 'lt',
  LU: 'fr',
  LV: 'lv',
  MA: 'ar',
  MC: 'fr',
  MD: 'ro',
  ME: 'sr',
  MK: 'mk',
  MT: 'en',
  MX: 'es',
  MY: 'ms',
  NI: 'es',
  NL: 'nl',
  NO: 'no',
  NZ: 'en',
  PA: 'es',
  PE: 'es',
  PH: 'fil',
  PK: 'ur',
  PL: 'pl',
  PR: 'es',
  PT: 'pt',
  PY: 'es',
  RO: 'ro',
  RS: 'sr',
  RU: 'ru',
  SA: 'ar',
  SE: 'sv',
  SG: 'en',
  SI: 'sl',
  SK: 'sk',
  SM: 'it',
  SV: 'es',
  TH: 'th',
  TN: 'ar',
  TR: 'tr',
  TW: 'zh-TW',
  UA: 'uk',
  US: 'en',
  UY: 'es',
  VA: 'it',
  VE: 'es',
  VN: 'vi',
  ZA: 'en',
};

const GOOGLE_MAPS_REGION_BY_COUNTRY = {
  GB: 'uk',
};

const SUPPORTED_GOOGLE_MAPS_LANGUAGES = new Set([
  'af',
  'sq',
  'am',
  'ar',
  'hy',
  'az',
  'eu',
  'be',
  'bn',
  'bs',
  'bg',
  'my',
  'ca',
  'zh',
  'zh-CN',
  'zh-HK',
  'zh-TW',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'en-AU',
  'en-GB',
  'et',
  'fa',
  'fi',
  'fil',
  'fr',
  'fr-CA',
  'gl',
  'ka',
  'de',
  'el',
  'gu',
  'iw',
  'hi',
  'hu',
  'is',
  'id',
  'it',
  'ja',
  'kn',
  'kk',
  'km',
  'ko',
  'ky',
  'lo',
  'lv',
  'lt',
  'mk',
  'ms',
  'ml',
  'mr',
  'mn',
  'ne',
  'no',
  'pl',
  'pt',
  'pt-BR',
  'pt-PT',
  'pa',
  'ro',
  'ru',
  'sr',
  'sr-Latn',
  'si',
  'sk',
  'sl',
  'es',
  'es-419',
  'sw',
  'sv',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'uz',
  'vi',
  'zu',
]);

const normalizeRegion = countryCode => {
  if (typeof countryCode !== 'string') {
    return '';
  }

  const region = countryCode.trim().toUpperCase();

  return /^[A-Z]{2}$/.test(region) ? region : '';
};

const getIntlLanguageForRegion = region => {
  if (!region || typeof Intl === 'undefined' || typeof Intl.Locale !== 'function') {
    return null;
  }

  try {
    const locale = new Intl.Locale(`und-${region}`).maximize();

    return locale.language && locale.language !== 'und' ? locale.language : null;
  } catch (error) {
    return null;
  }
};

const getSupportedGoogleMapsLanguage = language => {
  return SUPPORTED_GOOGLE_MAPS_LANGUAGES.has(language) ? language : null;
};

export const getGoogleMapsLocaleForCountry = countryCode => {
  const region = normalizeRegion(countryCode);

  if (!region) {
    return {
      language: 'en',
    };
  }

  const mappedLanguage = GOOGLE_MAPS_LANGUAGE_BY_REGION[region];
  const intlLanguage = getIntlLanguageForRegion(region);

  return {
    language:
      getSupportedGoogleMapsLanguage(mappedLanguage) ||
      getSupportedGoogleMapsLanguage(intlLanguage) ||
      'en',
    region: GOOGLE_MAPS_REGION_BY_COUNTRY[region] || region,
  };
};
